var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "e_slider" },
    [
      _vm.items.length > 1
        ? _c(
            "button",
            {
              staticClass: "nav_btn prev",
              attrs: { type: "button", disabled: _vm.value === 0 },
              on: {
                click: function ($event) {
                  return _vm.movePrev()
                },
              },
            },
            [_c("span", { staticClass: "offscreen" }, [_vm._v("이전")])]
          )
        : _vm._e(),
      _vm.items.length > 1
        ? _c(
            "button",
            {
              staticClass: "nav_btn next",
              attrs: { type: "button", disabled: _vm.value === _vm.maxIndex },
              on: {
                click: function ($event) {
                  return _vm.moveNext()
                },
              },
            },
            [_c("span", { staticClass: "offscreen" }, [_vm._v("다음")])]
          )
        : _vm._e(),
      _vm.items.length > 1
        ? _c(
            "div",
            { staticClass: "slider_pagination" },
            _vm._l(_vm.items, function (item, idx) {
              return _c(
                "button",
                {
                  key: "page" + idx,
                  class: ["page_bullet", { on: idx === _vm.value }],
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("input", idx)
                    },
                  },
                },
                [_vm._v(_vm._s(idx + 1))]
              )
            }),
            0
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "slide_viewport",
          style: {
            width:
              _vm.viewportWidth + _vm.leftPeekExtra + _vm.rightPeekExtra + "px",
            marginLeft: -_vm.leftPeekExtra + "px",
            marginRight: -_vm.rightPeekExtra + "px",
            height: _vm.viewportHeight ? _vm.viewportHeight + "px" : "auto",
          },
        },
        [
          _c(
            "div",
            {
              ref: "track",
              staticClass: "slide_track",
              style: {
                gap: _vm.gap + "px",
                transform: "translateX(" + -_vm.slideOffset + "px)",
              },
            },
            _vm._l(_vm.items, function (item, idx) {
              return _c(
                "div",
                {
                  key: "slide" + idx,
                  ref: "slideItems",
                  refInFor: true,
                  class: ["slide_item", { on: idx === _vm.value }],
                  style: { flex: "0 0 " + _vm.slideWidths[idx] + "px" },
                  on: {
                    click: function ($event) {
                      idx !== _vm.value && _vm.$emit("input", idx)
                    },
                  },
                },
                [_vm._t("default", null, { item: item, index: idx })],
                2
              )
            }),
            0
          ),
        ]
      ),
      _vm._t("footer"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }